export default {
  computed: {
    /*title: {
      get () {
        return this.$t("message.Works");
      }
    },*/ //чтобы pageheader работал нужно чтобы title был - значение по умолчанию

    pageheader: {
      get () {
        let tmp=this.$store.getters.seo_title;
        if ( tmp==null || tmp.length==0 ) tmp=this.title;
        if ( tmp==null || tmp.length==0 ) tmp=$("#app-wrapper").data().pagetitle;
        if ( tmp==null || tmp.length==0 ) tmp='';

        return tmp;
      }
    },

    pagetext: {
      get () {
        let tmp=this.$store.getters.seo_text;
        if ( tmp==null ) tmp='';

        if(tmp.length>0){
          //setTimeout нужен, т.к. иначе livequery не сработает
          setTimeout( ()=>{
            window.global.readmore('#id_readmore',
              '<div style="margin-top:15px" class="read_more"><span class="pointer link-lined">'+this.$t("message.ReadMore")+'</span></div>',
              '<div style="margin-top:15px" class="read_more"><span class="pointer link-lined">'+this.$t("message.Hide")+'</span></div>',
              '100', 50);
          }, 50 );
        }

        return tmp;
      }
    },
  },

}



//////////////////
// WEBPACK FOOTER
// ./src/components/SeoMix.js
// module id = null
// module chunks = 